export default "__VITE_ASSET__BKJkTwb7__"